module.exports = __webpack_public_path__ + "img/logo-chefkoch.66076b34.svg";